import React, { Component } from 'react';
import { connect } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import { historyFilteringOptions } from './lookups';

import './styles.css';

// eslint-disable-next-line react/prefer-stateless-function
class HistoryFilterTitle extends Component {
  render() {
    const { selected: selectedProps } = this.props;
    let title = '';
    let filterCount = 0;
    historyFilteringOptions.forEach((item) => {
      if (find(selectedProps, code => code === item.code)) {
        title += `${item.label} ${filterCount < selectedProps.length - 1 ? '& ' : ''}`;
        filterCount += 1;
      }
    });
    return (
      <div>
        {
          selectedProps.length ?
            <div styleName="headerFilterTitle">
              {title}
            </div> : null
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selected: get(state, 'historyFilter.selected'),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryFilterTitle);



// WEBPACK FOOTER //
// ./src/components/History/HistoryFilterTitle.js